import React from 'react';
import Head from 'next/head';

import { WEBSITE_CDN } from 'utils/config';

const AppleTags = () => {
  return (
    <Head>
      <link rel="apple-touch-icon-precomposed" sizes="144x144" href={`${WEBSITE_CDN}/touch-icon-144.png`} />
      <link rel="apple-touch-icon-precomposed" sizes="114x114" href={`${WEBSITE_CDN}/touch-icon-114.png`} />
      <link rel="apple-touch-icon-precomposed" sizes="72x72" href={`${WEBSITE_CDN}/touch-icon-72.png`} />
      <link rel="apple-touch-icon-precomposed" href={`${WEBSITE_CDN}/touch-icon-57.png`} />
    </Head>
  );
};

export default AppleTags;
